import { Markdown, ResponseRenderer } from "@nlux/react";
import { Space } from "antd";
import { CopyToClipboardButton } from "./CopyToClipboardButton";
import { useRef } from "react";

// nlux-comp-message nlux_msg_complete nlux_msg_received > nlux-markdownStream-root > nlux-markdown-container

export const MistralResponseRenderer: ResponseRenderer<string> = ({
  containerRef,
  status,
  dataTransferMode,
  content,
}) => {
  const localContainerRef = useRef<HTMLDivElement>(null);
  return (
    <>
      {status === "complete" && (
        <Space style={{ justifyContent: "end" }} className="nlux-actions" direction="vertical">
          <CopyToClipboardButton
            onClick={() => {
              if (containerRef) {
                navigator.clipboard.writeText((containerRef.current as HTMLDivElement)?.innerText);
              } else {
                navigator.clipboard.writeText((localContainerRef.current as HTMLDivElement)?.innerText);
              }
            }}
          />
        </Space>
      )}
      <div className="nlux-markdownStream-root">
        <div className="nlux-markdown-container" ref={containerRef || localContainerRef}>
          {dataTransferMode === "batch" && <Markdown children={content} />}
        </div>
      </div>
    </>
  );
};
